module.exports = __webpack_public_path__ + "static/img/Bad Day-05.1d62396.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue14/Bad Day/Bad Day-05.jpg
// module id = TaD3
// module chunks = 7